// extracted by mini-css-extract-plugin
export default {"container":"U_5vbaQJIakF3MZM9WSj"};